import { gql } from '@apollo/client';

export const RESET_PASSWORD = gql`
  mutation validateReset($data: ValidateResetInput!) {
    validateReset(data: $data) {
      status
      error
    }
  }
`;
